import formataPayloadValuesDeOption from './formataPayloadValuesDeOption';

const formataPayloadValuesTabInstrucoesCobrancaRemessaExlusivoCNAB400 = ({ values }) => ({
	...formataPayloadValuesDeOption({ values, field: 'instrucao_1' }),
	...formataPayloadValuesDeOption({ values, field: 'instrucao_2' }),
});

export default formataPayloadValuesTabInstrucoesCobrancaRemessaExlusivoCNAB400;
